import axios from "axios";
import { getHeadersConfig } from "../utils/config";
import { joinURLs } from "../utils/urlUtil";
import StateHelper from "../utils/StateHelper";

let getAssignableUsersAbortController = new AbortController();

export const Users = {
  getAssignableUsers: async (setUsers:any) => {
    const assignableUsersState = StateHelper.getAssignableUsersState();
    if (assignableUsersState && assignableUsersState.length) {
      // Ensure cached users are also sorted
      const sortedCachedUsers = [...assignableUsersState].sort((a: any, b: any) => {
        const nameA = (a.name || '').toLowerCase();
        const nameB = (b.name || '').toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      setUsers(sortedCachedUsers);
      return;
    }

    if (getAssignableUsersAbortController) getAssignableUsersAbortController.abort();
    getAssignableUsersAbortController = new AbortController();
  
    const url = joinURLs("admin/clinks", process.env.REACT_APP_JUPITER_API_BASE_URL, window.location.href);
    const params = {
      "method": "getAssignableUsers"
    };
  
    try {
      const response:any = await axios.get(url, {...getHeadersConfig(), params, signal: getAssignableUsersAbortController.signal });
      // Sort users alphabetically by name
      const sortedUsers = response.data.users.sort((a: any, b: any) => {
        const nameA = (a.name || '').toLowerCase();
        const nameB = (b.name || '').toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      setUsers(sortedUsers);
      StateHelper.setAssignableUsersState(sortedUsers)
    } catch (error:any) {
      setUsers([]);
      StateHelper.setAssignableUsersState([]);
    }
  }
}